<shared-table
  (itemClicked)="selectClient($event)"
  (paginateNext)="paginateNext()"
  (paginatePrev)="paginatePrev()"
  [headers]="tableHeaders"
  [items]="data"
  [pagination]="pagination"
>
</shared-table>
